import React from "react";
import * as mock from "../mock";

// SiteContent context - loads from localStorage with mock defaults.
const STORAGE_KEY = "3e_site_content_v1";

const defaults = {
  siteInfo: mock.siteInfo,
  heroHighlights: mock.heroHighlights,
  serviceCards: mock.serviceCards,
  servicesList: mock.servicesList,
  testimonials: mock.testimonials,
  faqs: mock.faqs,
  openRoles: mock.openRoles,
  aboutValues: mock.aboutValues,
  privatePaySteps: mock.privatePaySteps,
  careSlides: mock.careSlides,
  photoSlides: mock.photoSlides,
  paymentSettings: mock.paymentSettings,
};

function loadContent() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return defaults;
    const parsed = JSON.parse(raw);
    // Shallow merge so new fields appear
    return { ...defaults, ...parsed };
  } catch { return defaults; }
}

function saveContent(c) {
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(c)); } catch {}
}

const Ctx = React.createContext({ content: defaults, update: () => {}, reset: () => {} });

export function SiteContentProvider({ children }) {
  const [content, setContent] = React.useState(loadContent);

  const update = React.useCallback((partial) => {
    setContent((prev) => {
      const next = typeof partial === "function" ? partial(prev) : { ...prev, ...partial };
      saveContent(next);
      return next;
    });
  }, []);

  const reset = React.useCallback(() => {
    try { localStorage.removeItem(STORAGE_KEY); } catch {}
    setContent(defaults);
  }, []);

  return <Ctx.Provider value={{ content, update, reset }}>{children}</Ctx.Provider>;
}

export function useSiteContent() { return React.useContext(Ctx); }
